// extracted by mini-css-extract-plugin
export default {"skipLinkContainer":"skipLinkContainer-pS1fdD4l3duEG5GVB8Ei","skipLink":"skipLink-dqdMIpqYWLHHP7uKxMis"};